import controller from './project-settings.controller';

const template = require('./project-settings.html');

export default {
    controller,
    template
};
